import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/commonPage',//公共页面详情
    name: 'commonPage', component: () => import( '../pages/commonPage.vue')
}, {
    path: '/download',//公共页面详情
    name: 'downloadPage', component: () => import( '../pages/downloadPage.vue')
}


]

const router = new VueRouter({
    routes
})

export default router

